<template>
<div class="content-class">
	<v-tabs color="black" dark slider-color="primary">
		<v-tab :key="'list'" ripple>Cliniques</v-tab>
		<v-tab :key="'add'" ripple>Ajouter</v-tab>

		<v-tab-item :key="'list'">
			<user-group-list ref="list" :url="'userGroups?filter=bot:$eq:'+$route.params.botId">
			</user-group-list>

		</v-tab-item>

		<v-tab-item :key="'add'">
			<user-group-form v-model="document" v-on:userGroupCreated="updateList">
			</user-group-form>
		</v-tab-item>
	</v-tabs>
</div>
</template>

<script>
import UserGroupList from '../../components/userGroups/userGroup.list'
import UserGroupForm from '../../components/userGroups/userGroup.form'

export default {
	data() {
		return {
			document: null
		}
	},
	methods: {
		updateList() {
			this.$refs.list.update()
		}
	},
	components: { UserGroupList, UserGroupForm }
}
</script>

<style lang="scss">
.content-class {
    width: 100%;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/userGroups/userGroup.list.vue